import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getPostLoginRoute } from '../constants/admin-access.constants';
import { AuthSessionService } from './auth-session.service';

@Injectable({ providedIn: 'root' })
export class RoleHomeService {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  homeUrlTree(): Observable<UrlTree> {
    return this.session.ready().pipe(
      map((profile) => {
        if (!profile) {
          return this.router.createUrlTree(['/login']);
        }
        return this.router.createUrlTree([
          getPostLoginRoute(profile.role, profile.isApproved),
        ]);
      }),
    );
  }

  homeUrlTreeForUid(_uid: string): Observable<UrlTree> {
    return this.homeUrlTree();
  }
}
